import type React from 'react';

import { Helmet } from 'react-helmet-async';

export const PageMeta: React.FC = () => {
	return (
		<Helmet>
			<title>Search</title>
		</Helmet>
	);
};
